import React, { type KeyboardEvent } from 'react';
import { IconButton } from '@atlaskit/button/new';
import type { CustomTriggerProps } from '@atlaskit/dropdown-menu/types';
import MoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';

type Props = {
	issueId?: string;
	label: string;
	isDisabled?: boolean;
} & Partial<CustomTriggerProps>;

export const Trigger = ({ issueId, triggerRef, ...triggerProps }: Props) => {
	const onTriggerKeyDown = (event: KeyboardEvent<HTMLElement>) => {
		// Arrow Up/Down already mapped to table rows and meatball menu trigger should work only on Click
		if (event.key === 'ArrowDown') {
			event.stopPropagation();
		}
	};

	return (
		<IconButton
			{...triggerProps}
			id={issueId}
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="issue-navigator-issue-operations.ui.button"
			appearance="subtle"
			icon={MoreIcon}
			ref={triggerRef}
			onKeyDown={onTriggerKeyDown}
			isTooltipDisabled
		/>
	);
};
